import { Location, Zmanim } from '@hebcal/core';
import { NEIGHBORHOOD_COORDS, NEIGHBORHOOD_ELEVATION_METERS, TZEIT_SUN_DEGREES } from '../config/constants';

/** Neve Shamir for Hebcal, with its height (sunset "from the height", as on the local calendar). */
export const hebcalLocation = new Location(
  NEIGHBORHOOD_COORDS.lat,
  NEIGHBORHOOD_COORDS.lng,
  true, // Israel
  'Asia/Jerusalem',
  'Ramat Bet Shemesh',
  'IL',
  undefined,
  NEIGHBORHOOD_ELEVATION_METERS
);

/** "HH:mm" in Israel time; seconds are dropped. */
export function formatTime(date: Date): string {
  return date.toLocaleTimeString('en-GB', {
    timeZone: 'Asia/Jerusalem',
    hour: '2-digit',
    minute: '2-digit',
    hour12: false,
  });
}

/** "HH:mm" in Israel time, rounded to the nearest minute (as the local calendar prints Tzeit HaShabbos). */
export function formatTimeRounded(date: Date): string {
  return formatTime(new Date(date.getTime() + 30000));
}

function noonOf(dateStr: string): Date {
  return new Date(`${dateStr}T12:00:00Z`); // noon UTC avoids day-rollover edge cases
}

/** Sunset from the height (MyZmanim's SunsetDefault, the calendar's "שקיעה מהגובה"). */
export function hebcalSunsetFromHeight(dateStr: string): Date {
  return new Zmanim(hebcalLocation, noonOf(dateStr), true).sunset();
}

/** Tzeit HaKochavim / Shabbos ends: the sun TZEIT_SUN_DEGREES below the horizon, "HH:mm". */
export function hebcalTzeit(dateStr: string): string {
  return formatTimeRounded(new Zmanim(hebcalLocation, noonOf(dateStr), false).tzeit(TZEIT_SUN_DEGREES));
}
